import { jsxs, jsx } from 'react/jsx-runtime';
import { keyframes, styled } from 'styled-components';

const blink = keyframes([
  `0%{opacity:1;}40%{opacity:0.1;}100%{opacity:0.1;}`
]);
const Typing = styled.div.withConfig({
  displayName: "TypingDots__Typing",
  componentId: "sc-cb314f3d-0"
})([
  `--dot-size:10px;--speed:1500ms;display:flex;align-items:center;span{content:'';animation:`,
  ` var(--speed) infinite;animation-fill-mode:both;height:var(--dot-size);width:var(--dot-size);background:var(--fabric-color-text-primary);border-radius:50%;&:nth-child(2){animation-delay:calc(var(--speed) * 0.2);}&:nth-child(3){animation-delay:calc(var(--speed) * 0.4);}}`
], blink);
const TypingDots = ({ dotSize = 10, dotColor = "black", gap = 5, speed = 1500 }) => {
  return /* @__PURE__ */ jsxs(Typing, {
    style: {
      "--dot-size": `${dotSize}px`,
      "--dot-color": dotColor,
      "--speed": `${speed}ms`,
      gap: `${gap}px`
    },
    children: [
      /* @__PURE__ */ jsx("span", {}),
      /* @__PURE__ */ jsx("span", {}),
      /* @__PURE__ */ jsx("span", {})
    ]
  });
};

export { TypingDots as default };
//# sourceMappingURL=TypingDots.js.map
